import React from 'react';
type PendingNoteProps = {
  children?: React.ReactNode;
  tone?: 'inline' | 'block';
};

/**
 * Internal review marker. Hidden on the customer-facing site; set
 * SHOW_INTERNAL_NOTES to true to reveal approval notes while editing.
 */
const SHOW_INTERNAL_NOTES = false;
export function PendingNote({
  children = 'Pending approval',
  tone = 'inline'
}: PendingNoteProps) {
  if (!SHOW_INTERNAL_NOTES) return null;
  if (tone === 'block') {
    return <div className="rounded-md border border-ice/25 bg-ice/[0.06] px-4 py-3 text-sm leading-relaxed text-ice" data-id="element-910" data-mp="3sinrlb4qaq58">
        {children}
      </div>;
  }
  return <span className="ml-1.5 inline-flex items-center rounded border border-ice/30 px-1.5 py-px align-middle text-[10px] font-medium uppercase tracking-wider text-ice/90" data-id="element-911" data-mp="5cn0t3ujn1yk">
      {children}
    </span>;
}